exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "table {\n  width: 98%;\n  margin: 1%; }\n  table td, table th {\n    border: 1px solid black;\n    text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/frontpage/frontpage.component.css
// module id = 364
// module chunks = 2